<div class="container-fluid">

  <div class="row mb-4">
    <div class="col-md-12 d-flex justify-content-end">
      <button type="button" class="help-btn" (click)="onHelp(true)" aria-label="Ayuda" title="Ayuda">
        <i class="fa fa-info"></i>
      </button>
    </div>
  </div>



  <div class="row">
    <div class="col-sm-12">
      <!-- Dropzone / selector -->
      <app-file-upload data-tour="upload-dropzone" (fileSelected)="handleFiles($event)" [multiple]="multiple"
        [extension]="['pdf']" [maxFiles]="maxFile" [maxFileSize]="maxFileSize" *ngIf="visible"></app-file-upload>
    </div>
  </div>

  <div class="row mt-2">
    <div class="col-md-12 text-end">
    </div>
  </div>

  <!-- Tabla/listado -->
  <div data-tour="upload-list">
    <app-paginacion *ngIf="currentItems.length > 0" [currentPage]="currentPage" [totalItems]="totalItems"
      [selectedPageSize]="pageSize" [paginatedData]="currentItems" [headers]="tableHeaders" [actions]="customActions"
      (pageChange)="onPageChange($event)" (pageSizeChange)="onPageSizeChange($event)" [loading]="spinner">
    </app-paginacion>
  </div>

  <!-- Modal Ver documento -->
</div>

<ng-template #content let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Ver Documento</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
  </div>

  <div class="modal-body">
    <iframe title="documento" *ngIf="documentPdfUrl" [src]="documentPdfUrl" width="100%" height="500px" frameborder="0"
      allowfullscreen></iframe>

    <div *ngIf="!documentPdfUrl" class="text-center p-4">
      Cargando documento o no hay documento para mostrar...
    </div>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-outline-dark" (click)="modal.close('Cerrar click')">Cerrar</button>
  </div>
</ng-template>